import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import CarRepairOutlinedIcon from "@mui/icons-material/CarRepairOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import StayPrimaryPortraitOutlinedIcon from "@mui/icons-material/StayPrimaryPortraitOutlined";

export const oemPromiseList = {
  osm: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get hassle-free vehicle delivery with low and flexible down payment options, which helps you purchase OSM Load Electric Vehicles at an affordable price",
    },

    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drive at Home:",
      answer:
        "Get a firsthand experience of the smooth and efficient performance of OSM commercial vehicles through test drives.",
    },

    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Options:",
      answer:
        "Explore guaranteed financing options to make owning an OSM electric auto more convenient.",
    },

    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Doorstep Service and Maintenance:",
      answer:
        "Enjoy dedicated service and maintenance support for OSM electric trucks at the place of your choice, ensuring their optimal functioning and longevity.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange:",
      answer:
        "Take advantage of Turno's old vehicle exchange program to easily transition to an OSM ev auto.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Assured Resale:",
      answer:
        "Experience peace of mind with Turno's guaranteed resale options for OSM electric vehicles, offering up to 40% of the vehicle's purchase value.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "Turno App:",
      answer:
        "Access the Turno mobile app to track your vehicle in real-time, monitor battery health, and receive vehicle condition information for enhanced convenience and peace of mind.",
    },
  ],
  piaggio: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get hassle-free vehicle delivery with low and flexible down payment options.",
    },

    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drive at Home:",
      answer:
        "Get a firsthand experience of the smooth and efficient performance of Piaggio Ape electric vehicles through test drives.",
    },

    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Options:",
      answer:
        "Explore guaranteed financing options to make owning an Piaggio Ape electric vehicle more convenient.",
    },

    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Doorstep Service and Maintenance:",
      answer:
        "Enjoy dedicated service and maintenance support for Piaggio Ape electric vehicles, ensuring their optimal functioning and longevity.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange:",
      answer:
        "Take advantage of Turno's old vehicle exchange program to easily transition to a Piaggio Ape electric vehicle.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Assured Resale:",
      answer:
        "Now Piaggio electric vehicle owners can enjoy a guaranteed resale value of up to 40% of the original purchase price.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "Turno App:",
      answer:
        "Access the Turno mobile app to track your vehicle in real-time, monitor battery health, and receive vehicle condition information for enhanced convenience and peace of mind.",
    },
  ],
  mahindra: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get hassle-free vehicle delivery with low and flexible down payment options.",
    },
    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drives:",
      answer:
        "Get a firsthand experience of the smooth and efficient performance of Mahindra electric vehicles through test drives.",
    },
    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Options:",
      answer:
        "Explore guaranteed financing options to make owning an Mahindra electric vehicles more convenient.",
    },
    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Service and Maintenance:      ",
      answer:
        "Enjoy dedicated service and maintenance support for Mahindra electric vehicles, ensuring their optimal functioning and longevity.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange:      ",
      answer:
        "Take advantage of Turno's old vehicle exchange program to easily transition to an Mahindra EV auto.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Assured Resale:",
      answer:
        "Experience the added benefit of Turno's assured resale value of up to 40% or ₹ 200,000 for Mahindra EV auto.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "Turno App:",
      answer:
        "Access the Turno mobile app to track your vehicle in real-time, monitor battery health, and receive vehicle condition information for enhanced convenience and peace of mind.",
    },
  ],
  euler: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Free Doorstep Test Drive: ",
      answer:
        "We offer test drives at the location of your choice for your convenience.",
    },
    {
      id: 2,
      icon: <CarRepairOutlinedIcon />,
      question: "Maintenance and Repair Services:",
      answer:
        "Post-sale services, such as maintenance and repair, are offered to keep your electric vehicle running smoothly.",
    },
    {
      id: 3,
      icon: <SellOutlinedIcon />,
      question: "Vehicle Exchange: ",
      answer:
        "Turno's old vehicle exchange program for an easy switch from CNG/diesel to an electric vehicle.",
    },
    {
      id: 4,
      icon: <PaymentsOutlinedIcon />,
      question: "Pre and Post-sale Support:",
      answer:
        "EV experts at Turno help you at every step of your EV-owning journey, from finding the right vehicle to documentation, financing, and post-sales support such as scheduling regular services.",
    },
  ],
  eulerHindiPromises: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "सबसे कम डाउनपेमेंट:",
      answer:
        "लोड EV की खरीद को आपके लिए किफ़ायती बनाने के लिए सबसे कम डाउनपेमेंट प्रदान करते है।",
    },
    {
      id: 2,
      icon: <CarRepairOutlinedIcon />,
      question: "गाड़ी एक्सचेंज:",
      answer:
        "CNG/डीज़ल से इलेक्ट्रिक गाड़ी में आसानी से स्विच करने के लिए Turno का पुराना गाड़ी एक्सचेंज प्रोग्राम भी है।",
    },
    {
      id: 3,
      icon: <SellOutlinedIcon />,
      question: "सुनिश्चित रीसेल:",
      answer:
        "केवल Turno 3 साल के बाद इलेक्ट्रिक लोड ऑटो के लिए 40% या ₹150,000 तक का रीसेल मूल्य प्रदान करता है।",
    },
    {
      id: 4,
      icon: <PaymentsOutlinedIcon />,
      question: "मुफ्त डोरस्टेप टेस्ट ड्राइव:",
      answer:
        "हम आपकी सुविधा के लिए आपकी पसंद के जगह पर टेस्ट ड्राइव प्रदान करते हैं।",
    },
  ],
  etrio: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get hassle-free vehicle delivery with low and flexible down payment options, which helps you purchase Etrio Load Electric Vehicles at an affordable price",
    },

    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drive at Home:",
      answer:
        "Get a firsthand experience of the smooth and efficient performance of Etrio commercial vehicles through test drives.",
    },

    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Options:",
      answer:
        "Explore guaranteed financing options to make owning a Etrio electric auto more convenient.",
    },

    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Doorstep Service and Maintenance:",
      answer:
        "Enjoy dedicated service and maintenance support for Etrio 3 Wheeler at the place of your choice, ensuring their optimal functioning and longevity.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange:",
      answer:
        "Take advantage of Turno's old vehicle exchange program to easily transition to an Etrio EV auto.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Assured Resale:",
      answer:
        "Experience peace of mind with Turno's guaranteed resale options for Etrio electric vehicles, offering up to 40% of the vehicle's purchase value.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "Turno App:",
      answer:
        "Access the Turno mobile app to track your Etrio electric vehicle in real-time, monitor battery health, and receive vehicle condition information for enhanced convenience and peace of mind.",
    },
  ],

  altigreen: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get hassle-free vehicle delivery with low and flexible down payment options, which helps you purchase Altigreen Load Electric Vehicles at an affordable price",
    },

    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drive at Home:",
      answer:
        "Get a firsthand experience of the smooth and efficient performance of Altigreen commercial vehicles through test drives.",
    },

    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Options:",
      answer:
        "Explore guaranteed financing options to make owning an Altigreen electric auto more convenient.",
    },

    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Doorstep Service and Maintenance:",
      answer:
        "Enjoy dedicated service and maintenance support for Altigreen electric trucks at the place of your choice, ensuring their optimal functioning and longevity.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange:",
      answer:
        "Take advantage of Turno's old vehicle exchange program to easily transition to an Altigreen ev auto.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Assured Resale:",
      answer:
        "Experience peace of mind with Turno's guaranteed resale options for Altigreen electric vehicles, offering up to 40% of the vehicle's purchase value.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "Turno App:",
      answer:
        "Access the Turno mobile app to track your vehicle in real-time, monitor battery health, and receive vehicle condition information for enhanced convenience and peace of mind.",
    },
  ],

  greaves: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "Lowest Down Payment:",
      answer:
        "Get started with electric mobility with low and flexible down payment options for Greaves Electric Vehicles.",
    },
    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "Test Drive at Your Convenience:",
      answer:
        "Schedule a test drive to experience the performance and features of Greaves EVs at your preferred location.",
    },
    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "Financing Solutions:",
      answer:
        "Explore financing options tailored to your needs to make owning a Greaves electric vehicle more convenient.",
    },
    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "Service and Maintenance:",
      answer:
        "Enjoy dedicated service and maintenance support for Greaves Electric Vehicles at your convenience.",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "Vehicle Exchange Program:",
      answer:
        "Transition to a Greaves EV with ease through Turno's old vehicle exchange program.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "Resale Assurance:",
      answer:
        "Experience peace of mind with Turno's guaranteed resale options for Greaves Electric Vehicles.",
    },
  ],
};

export const oemPromiseListHindi = {
  mahindra: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "कम डाउन पेमेंट:",
      answer:
        "कम डाउन पेमेंट और विभिन्न EMI विकल्पों के साथ, आप बिना किसी परेशानी के इलेक्ट्रिक गाड़ी खरीद सकते हैंं।  ",
    },
    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "टेस्ट ड्राइव:",
      answer:
        " महिंद्रा इलेक्ट्रिक गाड़ियों की टेस्ट ड्राइव आप अपने घर पर कर रहकर भी सकते हैंं। वल्कि आप इस गाड़ी को पूरे एक दिन के लिए इस्तेमाल करके यह पता लगा सकते हैंं कि यह आपके व्यापार के लिए सही हैं या नहीं।",
    },
    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "लोन की सुविधा:",
      answer:
        "महिंद्रा इलेक्ट्रिक गाड़ियों को खरीदना आसान और सुविधाजनक बनाने के लिए टर्नो में किफायती कीमतों पर लोन की सुविधा उपलब्ध हैं।",
    },
    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "सर्विसिंग:",
      answer:
        "महिंद्रा इलेक्ट्रिक गाड़ियों के सर्विसिंग के लिए टर्नो की सेवा और सर्विस सुविधाओं का आनंद उठाए। घर बैठे सर्विसिंग कराएं और अपने व्यापार के लिए इस्तेमाल करें।",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "गाड़ी बदलें:",
      answer:
        "टर्नो पर पुरानी गाड़ी को बेचकर नई गाड़ी खरीदने के फायदे उठाएं। आप आसानी से अपनी पुरानी गाड़ी को टर्नो में बेचकर महिंद्रा लोडिंग गाड़ी घर ले जा सकते हैंं।",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "गारंटीड रीसेल:",
      answer:
        "टर्नो में आपको सबसे अधिक रीसेल मूल्य मिलता हैं, जिसमें महिंद्रा इलेक्ट्रिक ऑटो के लिए 40% तक या ₹2,00,000 का मूल्य आपको मिल सकता हैं।",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "टर्नो ऍप",
      answer:
        "टर्नो मोबाइल ऐप्लिकेशन का उपयोग करके अपनी गाड़ी को वास्तविक समय में ट्रैक करना, बैटरी की स्वास्थ्य को मॉनिटर करना, गाड़ी की वर्त्तमान स्थिति जानना इत्यादि आसानी से कर सकते हैं।",
    },
  ],
};
export const oemPromiseListKannada = {
  mahindra: [
    {
      id: 1,
      icon: <PaymentsOutlinedIcon />,
      question: "ಕಡಿಮೆ ಡೌನ್ ಪೇಮೆಂಟ್:",
      answer:
        "ಯಾವುದೇ ತೊಂದರೆಯಿಲ್ಲದೆ ಕಡಿಮೆ ಮತ್ತು ಹೊಂದಿಕೊಳ್ಳುವ ಡೌನ್ ಪೇಮೆಂಟ್ ಆಯ್ಕೆಗಳೊಂದಿಗೆ ವಾಹನ ವಿತರಣೆಯನ್ನು ಪಡೆಯಿರಿ. ",
    },
    {
      id: 2,
      icon: <ElectricRickshawIcon />,
      question: "ಟೆಸ್ಟ್ ಡ್ರೈವ್‌ಗಳು:",
      answer:
        "ಟೆಸ್ಟ್ ಡ್ರೈವ್‌ಗಳ ಮೂಲಕ ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಗಳ ಸುಗಮ ಮತ್ತು ಪರಿಣಾಮಕಾರಿ ಕಾರ್ಯಕ್ಷಮತೆಯ ಪ್ರತ್ಯಕ್ಷ ಅನುಭವವನ್ನು ಪಡೆಯಿರಿ.",
    },
    {
      id: 3,
      icon: <CurrencyRupeeIcon />,
      question: "ಹಣಕಾಸು ಆಯ್ಕೆಗಳು:",
      answer:
        "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಗಳನ್ನು ಹೊಂದಲು ಹೆಚ್ಚು ಅನುಕೂಲಕರವಾಗಲು ಖಾತರಿಯ ಹಣಕಾಸು ಆಯ್ಕೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
    },
    {
      id: 4,
      icon: <ManageAccountsIcon />,
      question: "ಸೇವೆ ಮತ್ತು ನಿರ್ವಹಣೆ:",
      answer:
        "ಮಹೀಂದ್ರಾ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಗಳಿಗೆ ಮೀಸಲಾದ ಸೇವೆ ಮತ್ತು ನಿರ್ವಹಣೆ ಬೆಂಬಲವನ್ನು ಆನಂದಿಸಿ, ಅವುಗಳ ಅತ್ಯುತ್ತಮ ಕಾರ್ಯನಿರ್ವಹಣೆ ಮತ್ತು ದೀರ್ಘಾಯುಷ್ಯವನ್ನು ಖಾತ್ರಿಪಡಿಸಿಕೊಳ್ಳಿ. ",
    },
    {
      id: 5,
      icon: <CarRepairOutlinedIcon />,
      question: "ವಾಹನ ವಿನಿಮಯ:",
      answer:
        "ಮಹೀಂದ್ರಾ ಲೋಡಿಂಗ್ ವಾಹನಕ್ಕೆ ಸುಲಭವಾಗಿ ಪರಿವರ್ತನೆಯಾಗಲು ಟರ್ನೊದ ಹಳೆಯ ವಾಹನ ವಿನಿಮಯ ಕಾರ್ಯಕ್ರಮದ ಲಾಭವನ್ನು ಪಡೆದುಕೊಳ್ಳಿ.",
    },
    {
      id: 6,
      icon: <SellOutlinedIcon />,
      question: "ಖಚಿತವಾದ ಮರುಮಾರಾಟ:",
      answer:
        "ಮಹೀಂದ್ರ EV ಆಟೋಗೆ 40% ಅಥವಾ ₹ 200,000 ವರೆಗಿನ Turno ನ ಖಚಿತವಾದ ಮರುಮಾರಾಟ ಮೌಲ್ಯದ ಹೆಚ್ಚುವರಿ ಪ್ರಯೋಜನವನ್ನು ಅನುಭವಿಸಿ.",
    },
    {
      id: 7,
      icon: <StayPrimaryPortraitOutlinedIcon />,
      question: "ಟರ್ನೊ ಅಪ್ಲಿಕೇಶನ್:",
      answer:
        "ನಿಮ್ಮ ವಾಹನವನ್ನು ನೈಜ ಸಮಯದಲ್ಲಿ ಟ್ರ್ಯಾಕ್ ಮಾಡಲು, ಬ್ಯಾಟರಿ ಆರೋಗ್ಯವನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಲು ಮತ್ತು ವರ್ಧಿತ ಅನುಕೂಲಕ್ಕಾಗಿ ಮತ್ತು ಮನಸ್ಸಿನ ಶಾಂತಿಗಾಗಿ ವಾಹನ ಸ್ಥಿತಿಯ ಮಾಹಿತಿಯನ್ನು ಸ್ವೀಕರಿಸಲು ಟರ್ನೊ ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಪ್ರವೇಶಿಸಿ.",
    },
  ],
};
